/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Attachment_Too_ManyInputs */



/**
* | output |
* | --- |
* | "You can share up to {count} files with one message." |
*
* @param {Chat_Attachment_Too_ManyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_too_many = /** @type {((inputs: Chat_Attachment_Too_ManyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_Too_ManyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Je kan maximaal ${i?.count} bestanden per bericht delen.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous pouvez partager au maximum ${i?.count} fichiers par message.`)
	return /** @type {LocalizedString} */ (`You can share up to ${i?.count} files with one message.`)
});